export const description = 'For personalized service, please:';
export const signIn = 'Sign In';
